import React, { useState } from 'react';
import { Card, Form, Button, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { createGoldSymbol } from '../../services/admin';
import PageTitle from '../../Component/Comman/PageTitle';

const AddGoldSymbol = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        type: 'gold',
        baseAsset: '',
        quoteAsset: '',
        displayName: '',
        minQuantity: 0.01,
        maxQuantity: 100,
        tickSize: 0.0001
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: name.includes('Quantity') || name === 'tickSize' ? parseFloat(value) || 0 : value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            setLoading(true);
            await createGoldSymbol(formData);
            alert('Gold symbol added successfully');
            navigate('/admin/gold-symbols');
        } catch (error) {
            alert(error.message || 'Failed to add gold symbol');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="container-xxl">
            <PageTitle pagetitle="Add Gold Symbol" sidebutton={true} />
            <div className="row">
                <div className="col-lg-8">
                    <Card>
                        <Card.Header>
                            <Card.Title>Add Gold Symbol</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Symbol Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Display Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="displayName"
                                                value={formData.displayName}
                                                onChange={handleChange}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Base Asset</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="baseAsset"
                                                value={formData.baseAsset}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Quote Asset</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="quoteAsset"
                                                value={formData.quoteAsset}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Min Quantity</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                name="minQuantity"
                                                value={formData.minQuantity}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Max Quantity</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.01"
                                                name="maxQuantity"
                                                value={formData.maxQuantity}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                    <Col md={4}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Tick Size</Form.Label>
                                            <Form.Control
                                                type="number"
                                                step="0.0001"
                                                name="tickSize"
                                                value={formData.tickSize}
                                                onChange={handleChange}
                                                required
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Button type="submit" variant="primary" disabled={loading}>
                                    {loading ? 'Creating...' : 'Create Symbol'}
                                </Button>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default AddGoldSymbol;

